import List from './actions/list';
import Find from './actions/find';
import Create from './actions/create';
import Update from './actions/update';
import Delete from './actions/delete';
import Resource from './resource';

export default class ReportTemplate extends Resource {
  get resourceName() {
    return 'report_template';
  }

  get resourcesName() {
    return 'report_templates';
  }
}
// @ts-ignore
List.includeInto(ReportTemplate);
// @ts-ignore
Find.includeInto(ReportTemplate);
// @ts-ignore
Create.includeInto(ReportTemplate);
// @ts-ignore
Update.includeInto(ReportTemplate);
// @ts-ignore
Delete.includeInto(ReportTemplate);
